
import Config from 'arbitrip-common/client/utils/Config';

import ApiURLs_mapper from 'arbitrip-common/client/constants/ApiURLs';

const ApiURLs = ApiURLs_mapper(Config.api_urls);

export default ApiURLs;
